<script lang="ts">
    import { onMount } from 'svelte';
    import { link } from 'svelte-spa-router';
    import { location } from '../../framework/js/spaLocation';
    import { api } from '../../framework/js/api.js';
    import KnowledgeSourceList from './knowledge/KnowledgeSourceList.svelte';

    let briefTypeUuid = '';
    let briefTypeName = '';

    $: {
        const parts = $location.split('/').filter(Boolean);
        const idx = parts.indexOf('brief-types');
        briefTypeUuid = idx >= 0 && parts[idx + 1] ? parts[idx + 1] : '';
    }

    onMount(async () => {
        if (!briefTypeUuid) return;
        try {
            const response: any = await api.crudGet('xplorit-type-brief', briefTypeUuid);
            if (response?.success && response.data) {
                briefTypeName = response.data.name || 'Brief type';
            }
        } catch {
            briefTypeName = 'Brief type';
        }
    });
</script>

<div class="brief-type-knowledge-page">
    <nav class="breadcrumb" aria-label="Breadcrumb">
        <a use:link href="/admin/knowledge/brief-types">Brief-type knowledge</a>
        <span aria-hidden="true">/</span>
        <span>{briefTypeName || briefTypeUuid}</span>
    </nav>

    {#if briefTypeUuid}
        <KnowledgeSourceList
            scope="brief_type"
            briefTypeUuid={briefTypeUuid}
            scopeLabel={briefTypeName}
            pageTitle={briefTypeName ? `${briefTypeName} knowledge` : 'Brief-type knowledge'}
            pageSubtitle="Rubrics, exemplars, and scoring anchors for this brief type."
        />
    {/if}
</div>

<style>
    .brief-type-knowledge-page {
        width: 100%;
    }

    .breadcrumb {
        display: flex;
        align-items: center;
        gap: var(--space-2);
        margin-bottom: var(--space-4);
        color: var(--grey-secondary);
        font-size: var(--text-sm);
    }

    .breadcrumb a {
        color: var(--primary);
        text-decoration: none;
    }

    .breadcrumb a:focus-visible {
        outline: none;
        box-shadow: var(--focus-ring);
    }
</style>
